// removed by extract-text-webpack-plugin
module.exports = {"commentLabel":"OjE57-pcbxFBni_kWGYX4","confirmWarning":"_3GvwO6b_IZ_bLS_PYVVdX4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CancelTransferForm/styles.css
// module id = 3227
// module chunks = 0